import SpsCard from "./card/SpsCard";
import SpsCardTabbedPane from "./card/SpsCardTabbedPane";

export default SpsCard;
export { SpsCard, SpsCardTabbedPane };